


































import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { Role } from '../../../../../utils/RoleUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => Question,
    },
  },

  computed: {
    permissionOptions(): any {
      return [
        {
          text: this.$tc('model.oversightOrganization.label'),
          value: 'oversight',
        },
        {
          text: this.$tc('model.serviceProvider.label'),
          value: 'serviceprovider',
        },
      ];
    },
  },

  mounted() {
    this.$emit('input', {
      permission: this.value.permission || {
        visible: ['oversight', 'serviceprovider'],
        editable: ['serviceprovider'],
      },
    });
  },
});
